import { useEffect } from "react";

import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { fr } from "date-fns/locale";

import moment from "moment";
import FormField from "../../../layouts/ecommerce/products/new-product/components/FormField";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";

import MDInput from "../../../components/MDInput";
import MDBox from "../../../components/MDBox";

import { useSelector, useDispatch } from "react-redux";

import { getUsers } from "api/users";

import { setAllUsers } from "redux/reducers/usersReducer";

export default function DeviceCommentaries({
  commentaryUserId,
  setCommentaryUserId,
  commentaryDate,
  setCommentaryDate,
  commentaryAction,
  setCommentaryAction,
}) {
  const dispatch = useDispatch();
  const allUsers = useSelector((state) => state.users.allUsers);

  async function fetchUsers() {
    const response = await getUsers();
    const formatedUsers = await response.data.map((user) => ({
      label: user.name,
      id: user.user_id,
    }));
    dispatch(setAllUsers(formatedUsers));
  }
  useEffect(() => {
    fetchUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <MDBox>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Autocomplete
            options={allUsers}
            value={commentaryUserId}
            required
            onChange={(event, newcommentaryUserId) => {
              setCommentaryUserId(newcommentaryUserId);
            }}
            renderInput={(params) => <MDInput {...params} label="Nom" variant="standard" />}
          />
        </Grid>
        <Grid item xs={6}>
          <Stack component="form" noValidate>
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
              <DatePicker
                slotProps={{ field: { clearable: true } }}
                displayWeekNumber
                label="Choisissez la date"
                value={commentaryDate && new Date(commentaryDate)}
                onChange={(newValue) => {
                  if (newValue === null) {
                    setCommentaryDate(null);
                  } else setCommentaryDate(moment(newValue).format("YYYY-MM-DD"));
                }}
                renderInput={(params) => <TextField {...params} fullWidth />}
                format="dd/MM/yyyy"
              />
            </LocalizationProvider>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <FormField
            multiline
            minRows={2}
            value={commentaryAction}
            onChange={(event) => setCommentaryAction(event.target.value)}
            required
            variant="outlined"
            type="text"
            label="Commentaire"
          />
        </Grid>
      </Grid>
    </MDBox>
  );
}
